/**
 * Filmi — AI-illustrated teen film-buff mascot for Filmistani.
 *
 * Renders the transparent-background PNG directly with a subtle drop-shadow.
 * No wrapper circle — the character floats freely against any backdrop.
 *
 * Premium idle animation (`fm-filmi-idle`) combines a slow 6-second
 * gentle vertical drift + occasional eye-blink-style scale squash so
 * Filmi always feels alive without being distracting.
 *
 * Props:
 *   size:     px (default 64) — fixed square box; PNG is roughly 1:1 ratio
 *   blink:    boolean — triggers a quick 180ms squash on Y to mimic a blink
 *   floating: boolean — enables the gentle 2.4s up/down hover (deprecated;
 *             new default is the smoother 6-second idle on the mascot itself)
 *   animated: boolean (default true) — toggles the premium idle animation
 */
export default function FilmiMascot({
  size = 64,
  blink = false,
  floating = false,
  animated = true,
  className = "",
}) {
  return (
    <img
      src="/filmi-mascot.png"
      width={size}
      height={size}
      alt="Filmi"
      role="img"
      data-testid="filmi-mascot"
      draggable="false"
      className={`select-none object-contain pointer-events-none
        ${animated ? "fm-filmi-idle" : ""}
        ${floating ? "fm-filmi-float" : ""}
        ${blink ? "fm-filmi-blink" : ""}
        ${className}`}
      style={{
        width: size,
        height: size,
        filter:
          "drop-shadow(0 6px 16px rgba(0, 0, 0, 0.55)) drop-shadow(0 0 22px rgba(229, 9, 20, 0.18))",
      }}
    />
  );
}
